import React, { useState, useEffect, useRef } from 'react';
import { translate } from '../Services/translation';

const FacetedSearchCompact = ({ facetFilters, visibleDropdownMenu, toggleVisibleDropdownMenu, onFacetChange, onSubmit }) => {
  const [selGroup, setGroup] = useState(null);
  const categoryRef = useRef(null);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (selGroup && visibleDropdownMenu.includes(selGroup.id) && categoryRef.current && !e.target.closest('.faceted-search')) {
        toggleVisibleDropdownMenu(selGroup);
      } 
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [visibleDropdownMenu]);

  return (
    <ul className='faceted-search faceted-search--compact row' ref={categoryRef}>
      <li className='title-list hide-for-large'>
        <h3>{translate('general.filter')} </h3>
      </li>
      {facetFilters &&
        facetFilters.map(
          (group, groupIndex, array) =>
            group.options &&
            group.options.filter((o) => o.quantity > 0).length > 0 && ( 
              <li className='faceted-search__group' key={`${group.label}-${groupIndex}`}>
                <div
                  className={`faceted-search__group-header ${visibleDropdownMenu.includes(group.id) ? 'faceted-search__group-header--show-compact' : ''}`}
                  onClick={(event) => {
                    toggleVisibleDropdownMenu(group);
                    setGroup(group);
                  }}
                >
                  {group.label}
                </div>
                <ul className='faceted-search__sublist'>
                  {group.options &&
                    group.options.map(
                      (item, itemIndex, array) =>
                        !isNaN(item.quantity) &&
                        item.quantity > 0 && (
                          <li key={`${item.label}-${itemIndex}`} className='faceted-search__item' role='option'>
                            <FacetedFilterCheckbox item={item} group={group} onFacetChange={onFacetChange} />
                          </li>
                        )
                    )}
                  {/* <li className='faceted-search__item' >
                        <button className='filter__button' onClick={event => {toggleVisibleDropdownMenu(group);onSubmit(facetFilters)}}>{translate('general.select')}</button>
                    </li> */}
                </ul>
              </li>
            )
        )}
    </ul>
  );
};
const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
  <label className='faceted-filter'>
    <input className='faceted-filter__input' type='checkbox' onChange={(event) => onFacetChange(group, item)} checked={group.selectedOptions.includes(item.id)} />
    <span className='faceted-filter__label'>
      {item.label}
      {!isNaN(item.quantity) && item.quantity > 0 && <span className='faceted-filter__quantity'> ({item.quantity})</span>}
    </span>
  </label>
);

export default FacetedSearchCompact;
